import { useTranslator } from '@bluebeam/react-i18n';
import { useAuth } from 'auth';
import { LinkTab, LinkTabs } from 'components/LinkTabs';
import Navigation from 'components/Navigation';
import { Route } from 'components/Routes/Route';
import React, { useEffect, useState } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import { Role } from 'records/Role';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import ApprovedTab from './ApprovedTab';
import MySubmittalsTab from './MySubmittalsTab';
import SubmittalLogTab from './SubmittalLogTab';

// import RequestsTab from './RequestsTab';

interface Props extends RouteComponentProps, WithAppStoreProps {}

const SubmittalsPage = (props: Props) => {
  const { userId } = useAuth();
  useEffect(() => {
    getSubmittalStatusesAndCategories();
    return () => {
      props.actions.clearInteractions();
    };
  }, []);

  const [statusesAndCategoriesLoaded, setStatusesAndCategoriesLoaded] =
    useState<boolean>(false);

  const { translate } = useTranslator(['submittalsPage']);

  const getSubmittalStatusesAndCategories = async (): Promise<void> => {
    await props.actions.getSubmittalStatusesAndCategories();
    setStatusesAndCategoriesLoaded(true);
  };

  const { match, appState } = props;

  const { role } = appState.roles.get(userId, new Role());

  const defaultPath = role === 'admin' ? 'submittal-log' : 'my-submittals';

  return (
    <Navigation>
      {statusesAndCategoriesLoaded ? (
        <div className="column h100">
          <div className="mx4 mt3 column">
            <LinkTabs>
              {role === 'admin' ? (
                <LinkTab
                  name={translate('submittalsPage:submittalLog')}
                  path={`${match.url}/submittal-log`}
                />
              ) : null}
              <LinkTab
                name={translate('submittalsPage:approved')}
                path={`${match.url}/approved`}
              />
              {role !== 'admin' ? (
                <LinkTab
                  name={translate('submittalsPage:mySubmittals')}
                  path={`${match.url}/my-submittals`}
                />
              ) : null}
              {/* <LinkTab name="Requests" path={`${match.url}/requests`} /> */}
            </LinkTabs>
          </div>
          <Switch>
            <Route path={`${match.url}/approved`} component={ApprovedTab} />
            <Route
              path={`${match.url}/submittal-log`}
              component={SubmittalLogTab}
            />
            <Route
              path={`${match.url}/my-submittals`}
              component={MySubmittalsTab}
            />
            {/* Need to work out when exactly "requests" routes should show up */}
            {/* <Route path={`${match.url}/requests`} component={RequestsTab} /> */}
            <Route
              path={match.url}
              render={(): React.ReactNode => (
                <Redirect to={`${match.url}/${defaultPath}`} />
              )}
            />
          </Switch>
        </div>
      ) : null}
    </Navigation>
  );
};

export default withAppStore<Props>(SubmittalsPage);
